// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export enum OperationalState {
  All = 'All',
  TotalDown = 'TotalDown',
  PartiallyDown = 'PartiallyDown',
  NoImpact = 'NoImpact',
}

export enum ActivityStatus {
  All = 'All',
  Scheduled = 'Scheduled',
  Overdue = 'Overdue',
  Done = 'Done',
}

export enum OperationalStateColor {
  Red = 'red',
  Green = 'green',
  Yellow = 'yellow',
  Grey = 'grey',
}

export enum TicketType {
  All = 'All',
  ServiceTicket = 'ServiceTicket',
  Maintenance = 'Maintenance',
  Update = 'Update',
}

export enum TicketStatus {
  Closed = 'Closed',
  Open = 'Open',
}

export enum ActivityStatusColor {
  Red = 'red',
  Green = 'green',
}
